import { Modal, styled, Typography, Box, Avatar } from '@material-ui/core';

export const NameLabel = styled(Typography)(() => ({
  fontSize: 24,
  fontWeight: 700,
  marginBottom: 40,
  lineHeight: '24px',
}));

export const ModalContainer = styled(Modal)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
});

export const ModalContent = styled(Box)({
  padding: 24,
  flex: 1,
  overflow: 'hidden',
  display: 'flex',
  flexDirection: 'column',
  minHeight: 0,
  width: 660,
});

export const ModalTitle = styled(Typography)({
  fontSize: 20,
  fontFamily: 'Red Hat Display',
  fontWeight: 700,
  marginBottom: 24,
});

export const FormContainer = styled(Box)({
  display: 'flex',
  width: '100%',
  gap: 24,
  flexDirection: 'column',
});

export const ModalActions = styled(Box)({
  display: 'flex',
  justifyContent: 'flex-end',
  gap: 16,
  marginBottom: 8,
});

export const StyledAvatar = styled(Avatar)(({ theme }) => ({
  width: 96,
  height: 96,
  fontSize: 96 * 0.7,
  border: `1px solid ${theme.palette.text.secondary}`,
  backgroundColor: theme.palette.text.secondary,
}));
